export const trimSearchFilter = (searchFilter?: string): string | undefined => {
	if (searchFilter === undefined) {
		return undefined;
	}
	return searchFilter.trim() || undefined;
};
